import { render, staticRenderFns } from "./KioskPage.vue?vue&type=template&id=1dc9b1b1&"
import script from "./KioskPage.vue?vue&type=script&lang=js&"
export * from "./KioskPage.vue?vue&type=script&lang=js&"
import style0 from "./KioskPage.vue?vue&type=style&index=0&id=1dc9b1b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports